<template>
  <div class="i-coaching-upsell-home">
    <div class="top">
      <iBaseHeader
        highlight-text=""
        text="Get Expert Help"
        font-size-text="16px"
        align="center"
      />
      <div class="text">Supercharge your career with a personalized career coach.</div>
    </div>
    <div class="bottom">
      <img
        :src="isXLargeScreen ? ImageCoachingLg : ImageCoaching"
        alt="Coaching Image"
      />
      <iBaseButton
        class="cta"
        v-bind="BUTTON_STYLE"
        text="Check Availability"
        @clicked="linkToCoachSelection"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { black, sorbus400 } from "@/styles/colors"
import { breakpointXl } from "@/styles/variables"

import useIsScreenSize from "@/composables/useIsScreenSize"
import linkToCoachSelection from "@/composables/linkToCoachSelection"

import iBaseHeader from "@/components/base/BaseHeader.vue"
import iBaseButton from "@/components/base/BaseButton.vue"

// ASSETS
import ImageCoaching from "@/assets/home/coaching-upsell.png"
import ImageCoachingLg from "@/assets/home/coaching-upsell-lg.png"

// COMPOSABLES
const isXLargeScreen = useIsScreenSize(breakpointXl)

// CONSTANTS
const BUTTON_STYLE = {
  size: "small",
  fontWeight: "500",
  width: "100%",
  backgroundColor: sorbus400,
  borderRadius: "8px",
  textColor: black,
  padding: "12px 12px"
}
</script>

<style lang="scss" scoped>
.i-coaching-upsell-home {
  @include flex(column, start, center, $gap: 30px);

  padding: 20px;
  width: 100%;
  background-color: $black50;

  @media screen and (min-width: $breakpoint-xl) {
    min-width: 50%;
    width: 50%;
    border-bottom: 1px solid $zumthor100;
    border-left: 1px solid $zumthor100;
    height: 100%;
    background-color: transparent;
  }

  .top {
    @include flex(column, start, center, $gap: 15px);

    .text {
      text-align: center;

      @include text-md;

      font-weight: 600;
      color: $pickle-bluewood800;

      @media screen and (min-width: $breakpoint-xl) {
        @include text-sm;
      }
    }
  }

  .bottom {
    @include flex(column, start, center);

    width: fit-content;

    img {
      width: 250px;

      @media screen and (min-width: $breakpoint-sm) {
        width: 400px;
      }

      @media screen and (min-width: $breakpoint-xl) {
        width: auto;
      }
    }

    .cta {
      box-shadow: 0 -30px 15px rgb(255 255 255 / 80%);
    }
  }
}
</style>
